// extracted by mini-css-extract-plugin
module.exports = {"phoneInputLabel":"TFBPhoneInput_phoneInputLabel__3Q46K","phoneInputGroup":"TFBPhoneInput_phoneInputGroup__2YpmN"};